import { useEffect, useState } from "react";

// Returns `value` delayed by `delay` ms. Used to debounce search inputs so we
// don't fire an API call on every keystroke. 400ms matches the prompt's
// "debounced 400ms" requirement for the Organizations search bar.
export const useDebouncedValue = (value, delay = 400) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(handle);
  }, [value, delay]);

  return debounced;
};

export default useDebouncedValue;
